// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"_P-z","smallCardRow":"aQ-z","largeCardRow":"bQ-z","productSearchRow":"cQ-z","curatedRow":"dQ-z"};